import { TAccount } from '@helpers/Accounts/accounts.types';
import { Pill, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { useGetDashboardTitleData } from './useGetDashboardTitleData';
import { LoanStatusPill } from '../loanStatusPill/LoanStatusPill';
import { LoanTitle } from '../loanTitle/LoanTitle';
import { RCFStatusPill } from '../rcfStatusPill/RCFStatusPill';

export const DashboardTitle = ({
    accountId
}: {
    accountId: NonNullable<TAccount['account_id']>;
}) => {
    const { loanStatus, isInInterestOnlyPeriod, isRCF } =
        useGetDashboardTitleData(accountId);

    if (isRCF) {
        return (
            <div className="flex flex-row items-center gap-m">
                <Text className="my-0 text-2xl font-bold min-sm:text-3xl">
                    <FormattedMessage
                        id="_.dashboard.rcf_title"
                        defaultMessage="Flexi credit line"
                    />
                </Text>
                <RCFStatusPill />
            </div>
        );
    }

    return (
        <div className="col-span-7 flex flex-row items-center">
            <Text className="m-0 text-3xl font-bold max-sm:text-xl">
                <LoanTitle accountId={accountId} />
            </Text>
            {isInInterestOnlyPeriod && (
                <Pill className="ml-s">
                    <FormattedMessage
                        id="_.outstanding_view.interestOnlyPillName"
                        defaultMessage="Interest Only"
                    />
                </Pill>
            )}
            <LoanStatusPill loanStatus={loanStatus} />
        </div>
    );
};
